/**
 * Profile Action Type Constants
 * @type {string}
 */
export const SET_PROFILE = 'SET_PROFILE'

/**
 * Set profile
 * @param profile
 * @param token
 * @returns {{payload: *, type: string, token: *}}
 * @private
 */
export const _setProfile = (profile, token) => ({
  type: SET_PROFILE,
  payload: { profile, token }
})

/**
 * Dispatch SET_PROFILE
 */
export const setProfile = (profile, token) => (dispatch) => {
  return dispatch(_setProfile(profile, token))
}
